import React, { useEffect, useRef, useState } from "react";

const ExpandableText = ({ text, className, onCollapse, maxLines = 15 }: { 
  text: string, 
  className: string, 
  onCollapse?: () => void,
  maxLines?: number 
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [showViewMore, setShowViewMore] = useState(false);
  const textRef = useRef<HTMLDivElement>(null);

  // Check if line-clamp is supported
  const supportsLineClamp = typeof CSS !== 'undefined' && 
    CSS.supports && 
    CSS.supports('-webkit-line-clamp', '1');

  useEffect(() => {
    if (textRef.current) {
      const shouldTruncate = textRef.current.scrollHeight > textRef.current.clientHeight;
      setShowViewMore(shouldTruncate);
    }
  }, [text]);

  return (
    <div id="expandable-text-container" className={className}>
      <div 
        id="expandable-text"
        ref={textRef}
        style={{
          ...(supportsLineClamp ? {
            // Modern browsers: use line-clamp
            display: '-webkit-box',
            WebkitLineClamp: isExpanded ? 'unset' : maxLines,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden'
          } : {
            // Fallback: use max-height
            maxHeight: isExpanded ? 'none' : `${maxLines * 1.5}em`,
            overflow: 'hidden',
            position: 'relative'
          })
        }}
      >
        {text}
      </div>
      {/* Fallback: show ellipsis if line-clamp is not supported */}
      {!isExpanded && showViewMore && !supportsLineClamp && <div>...</div>}
      {showViewMore && (
        <span
          id="view-more-link"
          onClick={(e) => {
            e.stopPropagation();
            setIsExpanded(!isExpanded);
            if (isExpanded && onCollapse) {
              onCollapse();
            }
          }}
          style={{
            color: 'inherit',
            cursor: 'pointer',
            fontSize: '0.9em',
            textDecoration: 'underline',
            marginTop: '0.25em',
            opacity: 0.7,
            display: 'inline-block'
          }}
          className="view-more-link"
        >
          {isExpanded ? 'View Less' : 'View More'}
        </span>
      )}
    </div>
  );
};

export default ExpandableText;